import { render } from "./SLink.vue?vue&type=template&id=049fad43&scoped=true&ts=true"
import script from "./SLink.vue?vue&type=script&lang=ts"
export * from "./SLink.vue?vue&type=script&lang=ts"

import "./SLink.vue?vue&type=style&index=0&id=049fad43&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049fad43"]])

export default __exports__